export const fieldLabels = {
  inclusionExclusion: "Included/Excluded",
  recognitionPermissionType: "Recognition Permission Type",
  qualificationType: "Qualification Type",
  level: "Level",
  sectorSubjectArea: "Sector Subject Area",
  tLevelSubject: "Technical Qualification Subject",
  apprenticeshipStandard: "Apprenticeship Standard",
  qualificationDescription: "Qualification Description",
  accepted: "Accepted",
  rejected: "Rejected",
  validStartDate: "Valid start",
  status: "Status"
};